import * as d3 from "d3";

const formatMillisecond = d3.timeFormat(".%L");
const formatSecond = d3.timeFormat(":%S");
const formatMinute = d3.timeFormat("%H:%M");
const formatHour = d3.timeFormat("%H:00");
const formatDay = d3.timeFormat("%d %b");
const formatWeek = d3.timeFormat("%b %d");
const formatMonth = d3.timeFormat("%b");
const formatYear = d3.timeFormat("%Y");

export type DateLike = Date | number | { valueOf(): number };

// We can decorate functions with this converter
export function fromDateLikeToDate(d: DateLike): Date {
  if (d instanceof Date) {
    return d;
  }
  if (typeof d === "number") {
    return new Date(d);
  }
  return new Date(d.valueOf());
}

export function tickTimeFormat(d: DateLike): string {
  const date: Date = fromDateLikeToDate(d);

  return (d3.timeSecond(date) < date
    ? formatMillisecond
    : d3.timeMinute(date) < date
    ? formatSecond
    : d3.timeHour(date) < date
    ? formatMinute
    : d3.timeDay(date) < date
    ? formatHour
    : d3.timeMonth(date) < date
    ? d3.timeWeek(date) < date
      ? formatDay
      : formatWeek
    : d3.timeYear(date) < date
    ? formatMonth
    : formatYear)(date);
}
